const RF_TLD_ASCII = 'xn--p1ai';

export const REGISTRATION_EMAIL_DOMAIN_HINT =
  'Для регистрации используйте адрес в доменной зоне .ru или .рф (например, name@mail.ru или name@почта.рф).';

export const REGISTRATION_EMAIL_DOMAIN_ERROR =
  'Регистрация доступна только с почтовым адресом в зоне .ru или .рф.';

function domainToAscii(domain) {
  const trimmed = domain.trim().toLowerCase().replace(/\.+$/, '');
  if (!trimmed) {
    return null;
  }

  if (trimmed === 'рф' || trimmed.endsWith('.рф')) {
    return trimmed;
  }

  if (trimmed === 'ru' || trimmed.endsWith('.ru')) {
    return trimmed;
  }

  try {
    return new URL(`http://${trimmed}`).hostname;
  } catch (_) {
    return null;
  }
}

function isAllowedRegistrationDomain(domain) {
  if (!domain) {
    return false;
  }

  if (domain === 'рф' || domain.endsWith('.рф')) {
    return true;
  }

  if (domain === 'ru' || domain.endsWith('.ru')) {
    return true;
  }

  return (
    domain === RF_TLD_ASCII
    || domain.endsWith('.ru')
    || domain.endsWith(`.${RF_TLD_ASCII}`)
  );
}

export function isAllowedRegistrationEmail(email) {
  if (!email || !email.includes('@')) {
    return false;
  }

  const at = email.lastIndexOf('@');
  const local = email.slice(0, at);
  const domainPart = email.slice(at + 1);
  if (!local || !domainPart) {
    return false;
  }

  const domain = domainToAscii(domainPart);
  return isAllowedRegistrationDomain(domain);
}
